const rabbitProxy = 'https://rbproxy.znaesh-test.pp.ua/sendEmailToRabbit'

const authData = {
  user: process.env.REACT_APP_USER,
  pass: process.env.REACT_APP_PASS,
  to: 'info@xleumconstruction.com',
}
export { authData, rabbitProxy }
